import '../css/main.scss';
import './main';
import './sliders';

console.log('Loaded!');
